




































































import {Component, Vue} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import {LadingCodeStore} from "@/modules/ladingcodes/store";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import LadingCodePrint from "@/modules/ladingcodes/shared/components/LadingCodePrint/index.vue";
import {Options} from "@/plugins/print/lib/print";
import {getPublicPath} from "@/shared/services/helper/utils";
import LadingCodeA7Print from "@/modules/ladingcodes/shared/components/LadingCodeA7Print/index.vue";
import {FreightServiceStore} from "@/modules/freightservices/store";
import {FreightServiceParams} from "@/modules/freightservices/params";

const form = {
    customerRowGuid: undefined,
    quantity: undefined,
    status: undefined,
    print: false
};
@Component({
    name: "LadingCodeForm",
    components: {LadingCodeA7Print, LadingCodePrint, CustomerSelector, EnumSelector},
})
export default class extends Vue {
    CommonStatus = CommonStatus;
    ladingCodes = [];
    test = false;
    printObj: Options = {
        id: 'lading-code-print',
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`
    };
    printObjA7: Options = {
        id: 'print-lading-code-a7',
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print-landscape.css`,
    }

    form = {...form};

    rules = {
        customerRowGuid: [{ required: true, message: "Chọn khách hàng", trigger: "change" }],
        quantity: [
            { required: true, message: "Nhập số lượng", trigger: "change" }
        ],
        status: [{ required: false }],
    };

    created() {
        if (!FreightServiceStore.ids.length) {
            FreightServiceStore.listFreightService({ params: new FreightServiceParams() });
        }
    }

    onSubmit(print = false, template = 'normal') {
        (this.$refs.formLadingCode as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                if (print) {
                  this.form.print = true;
                }
                this.ladingCodes = await LadingCodeStore.createLadingCode(this.form);
                if (print) {
                    if (template === 'normal')
                        (this.$refs.printBtn as any).$el.click();
                    else
                        (this.$refs.printBtnA7 as any).$el.click();
                }
                this.$message.success({
                    content: `Tạo mã vận đơn thành công`
                });
                this.form = {...form};
                // this.$router.push({ name: "listLadingCode" });
            } catch (e) {
                this.$message.error({
                    content: `Tạo mã vận đơn thất bại`
                })
            }
        })
    }
}
